/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Event_TemplateInputs */



/**
* | output |
* | --- |
* | "Add To Templates" |
*
* @param {Context_Menu_Event_TemplateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_event_template = /** @type {((inputs?: Context_Menu_Event_TemplateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Event_TemplateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter aux modèles")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zu Vorlagen hinzufügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi ai modelli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить в шаблоны")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agregar a plantillas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("添加到模板")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テンプレートに追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेम्प्लेट में जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar aos modelos")
	return /** @type {LocalizedString} */ ("Add To Templates")
});